import type { DocumentColor } from "@bedrock/domain";

export const DOCUMENT_COLORS: readonly { value: DocumentColor; label: string }[] = [
  { value: "paper", label: "Paper" },
  { value: "lilac", label: "Lilac" },
  { value: "sky", label: "Sky" },
  { value: "mint", label: "Mint" },
  { value: "butter", label: "Butter" },
  { value: "peach", label: "Peach" }
];

export function documentColorLabel(color: DocumentColor): string {
  return DOCUMENT_COLORS.find((option) => option.value === color)?.label ?? "Paper";
}
